import { ApplicationStatus } from '../../types';
import { CreateActionParams } from '../actions';
import { getBusinessInfo } from './implementations/getBusinessInfo';
import { getUserInfo } from './implementations/getUserInfo';
import { getSelectedTimezone } from './implementations/getSelectedtTmezone';

export type InitializeWidget = () => void;

export function createInitializeWidgetAction({
  context,
  getControllerState,
}: CreateActionParams): InitializeWidget {
  return async () => {
    const [, setState] = getControllerState();

    const [businessInfo, userInfo] = await Promise.all([
      getBusinessInfo(context),
      getUserInfo(context),
    ]);

    const selectedTimezone = getSelectedTimezone({ businessInfo, userInfo });

    setState({
      status: ApplicationStatus.IDLE,
      businessInfo,
      userInfo,
      selectedTimezone,
    });
  };
}
